import { useLocation, Link } from "react-router-dom";
import { usePreviewSession } from "../../contexts/PreviewSessionContext";
import { isPathAllowed, getPageByKey } from "../../lib/preview-pages";

interface Props {
  children: React.ReactNode;
}

export default function PreviewRouteGuard({ children }: Props) {
  const previewCtx = usePreviewSession();
  const location = useLocation();

  if (!previewCtx?.session) return <>{children}</>;

  const { allowedPages } = previewCtx.session;
  if (isPathAllowed(location.pathname, location.search, allowedPages)) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="max-w-lg w-full bg-surface-200 border border-primary-400/30 rounded-2xl p-8 text-center">
        <h1 className="text-[#DDEBFF] text-xl font-semibold mb-2">
          This page isn't part of your preview
        </h1>
        <p className="text-[#6B96D6] text-sm mb-6">
          Your invited preview includes the following pages. Pick one to continue.
        </p>
        <ul className="space-y-2 text-left">
          {allowedPages.map((key) => {
            const page = getPageByKey(key);
            if (!page) return null;
            const to = page.tab ? `${page.path}?role=${page.tab}` : page.path;
            return (
              <li key={key}>
                <Link
                  to={to}
                  className="block w-full px-4 py-2 rounded-lg bg-primary-200/10 hover:bg-primary-200/20 text-[#DDEBFF] text-sm border border-primary-400/30 transition-colors"
                >
                  {page.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
